module.exports = __webpack_public_path__ + "static/media/Xero-offline-auto-import-invoices.1c588ff3.png";